import { isExperimentOn } from '@wix/domains-serverless-interface';
import { usePremiumEssentialsContext } from '@wix/premium-fed-sdk/@premium-essentials';
import { ExperimentSpecs } from '../constants';
export const useIsSiteLevelBrokerEnabled = () => {
  var _usePremiumEssentials;
  return isExperimentOn((_usePremiumEssentials = usePremiumEssentialsContext(false)) == null || (_usePremiumEssentials = _usePremiumEssentials.experiments) == null ? void 0 : _usePremiumEssentials[ExperimentSpecs.SiteLevelBroker]);
};
//# sourceMappingURL=useIsSiteLevelBrokerEnabled.js.map